<template lang="html">
  <div class="slds-tabs_default slds-sub-tabs">
    <ul class="slds-tabs_default__nav" role="tablist" style="overflow: overlay;">

      <li v-for="(tab, index) in tabs" v-bind:key="tab" 
        class="slds-tabs_default__item slds-sub-tabs__item slds-grid slds-grid_vertical-align-center" 
        v-bind:class="{ 'slds-active': isActive(index)}">
        <a v-on:click.prevent="clickTab(index)"
          href="javascript:void(0);"
          class="slds-tabs_default__link slds-p-horizontal_xx-small"
          v-bind:title="tab" role="tab"
          >

          <span class="slds-indicator-container"></span>
          <!--
          <span class="slds-icon_container" title="Campagna">
            <svg class="slds-icon slds-icon_small slds-icon-text-default" aria-hidden="true">
              <use xlink:href="/assets/icons/standard-sprite/svg/symbols.svg#case"></use>
            </svg>
            <span class="slds-assistive-text pippo">Campagna</span>
          </span>
        -->
          <span class="slds-truncate pippo" v-bind:title="tab">{{tab}}</span>
        </a>
      </li>
    </ul>
    <slot name="main"></slot>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  components: {

  },
  props: {
    tabs: Array,
    multi: Boolean,
    multidefault: Array
  },
  data() {
    return {
      activepage:'',
      activepages:[]
    }
  },
  computed: {

  },
  mounted: function() {
    if (this.tabs.length>0) {
      this.activepage=this.tabs[0];
      this.activepages.splice(0,this.activepages.length);
      if (this.multidefault) {
        for (var i=0;i<this.tabs.length;i++)
          this.activepages.push(this.multidefault[i]);
      }
    }
  },
  async created() {

  },
  methods: {
    isActive: function(index) {
      var t=this.tabs[index];
      if (!this.multi)
        return this.activepage==t;
      else
        return this.activepages[index];
    },
    clickTab: function(index) {
      var t=this.tabs[index];
      if (!this.multi)
        this.activepage=t;
      else
        this.$set(this.activepages,index,!this.activepages[index]);
        // this.activepages[index]=!this.activepages[index];
      this.$emit('change', index);
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
